// import SpacePreferenceModal from '@components/Modals/SpacePreferenceModal.js';
import DesktopNavbar from '@components/Navbar/DesktopNavbar.js';
import MobileNavbar from '@components/Navbar/MobileNavbar.js';
import {
  IS_APP,
  IS_MOBILE,
  IS_SHARED_VIEW,
  NAVBAR_WIDTH,
} from '@constants/global.js';
import MainDrawer from '@layouts/Drawer.js';
import ProjectPage from '@pages/Project';
import { subscribe } from '@router/index.js';
import { resizingPreview } from '@signals/CommonSignals';
import DrawerState from '@states/DrawerState';
import UserState from '@states/User.js';
import { UIDiv, UIElement } from '@ui';

class _MainLayout extends UIDiv {
  constructor() {
    super();
    this.navbar = IS_MOBILE() ? new MobileNavbar() : new DesktopNavbar();
    if (IS_MOBILE()) {
      this.addClass('flex-col-reverse');
    }

    this.addClass('main-layout flex w-full h-100dvh');
    this.setId('main-layout');

    this.contentWrapper = new UIDiv();
    // pb for mobile navbar
    this.contentWrapper.addClass(
      'page-content-wrapper min-w-0 bg-white relative md:pb-0',
    );
    this.contentWrapper.setStyle('height', [
      IS_MOBILE() && !IS_APP() ? 'calc(100dvh - 60px)' : '100%',
    ]);
    this.contentWrapper.setId('page-content-wrapper');

    this.add(this.contentWrapper);
    this.add(MainDrawer);

    this.hideNavbar = false;
    if (!IS_APP() && !IS_SHARED_VIEW()) {
      this.addFront(this.navbar);
      window.visualViewport.addEventListener('resize', () => {
        // when mobile keyboard is open, it used to trigger update.
        if (window.visualViewport.height < window.innerHeight) {
          return;
        }
        if (!this.hideNavbar) {
          this.updateNavbar();
        }
      });
    }
    if (!IS_MOBILE()) {
      resizingPreview.add(currentWidth => {
        this.#updateWidth(currentWidth);
      });
      DrawerState.subscribe(() => {
        this.#updateWidth();
      });
    }

    // Subscribe to router updates
    subscribe((content, title) => {
      if (MainDrawer.toggleButton.hasClass('flip')) {
        MainDrawer.toggleButton.removeClass('flip');
        MainDrawer.animateClose();
      }

      MainDrawer.toggleClass('hidden', true);
      MainDrawer.toggleClass('![bottom:0px]', IS_APP() || IS_SHARED_VIEW());

      // Don't clear drawer content if on mobile to preserve preview content
      if (!IS_MOBILE()) {
        MainDrawer.contentWrapper.clear();
        DrawerState.clear();
      }

      this.setContent(content);
      const isVisible = !this.shouldHideSidebar(title);
      this.toggleSidebar(isVisible);

      // Show space preference modal after user state is loaded
      // SpacePreferenceModal.show();
    });
  }

  #updateWidth(previewWidth) {
    const drawerContainerWidth =
      document.getElementById('drawer-global')?.getBoundingClientRect().width ||
      0;
    const deductionDrawer =
      DrawerState.drawer.isOpen && drawerContainerWidth > 0
        ? drawerContainerWidth
        : 0;
    const previewContainerWidth =
      previewWidth ||
      document.getElementById('preview-container')?.getBoundingClientRect()
        .width ||
      0;
    const navbarWidth = NAVBAR_WIDTH();
    const deductWidth = previewContainerWidth + navbarWidth + deductionDrawer;

    this.contentWrapper.setWidth(`calc(100% - ${deductWidth}px)`);
  }

  updateNavbar() {
    // THIS NEEDS TO BE ON TOP BECAUSE THE NAVABAR WILL BE REMOVED AFTER AND THE ELEMENTS WOULD BE GONE
    if (window.location.pathname === '/projects' && IS_MOBILE()) {
      const projects = document.querySelector('#projects-page');
      const projectsContent = new UIElement(projects);
      MainLayout.setContent(projectsContent);
      const projectsExpandButton = document.querySelector(
        '#expand-projects-toggle',
      );
      projectsExpandButton?.remove();
    }

    if (IS_MOBILE() && this.navbar.isDesktop) {
      const pageComponent = this.navbar.preview.component;
      this.remove(this.navbar);
      this.navbar = new MobileNavbar();
      this.contentWrapper.add(pageComponent);
    }
    if (!IS_MOBILE() && !this.navbar.isDesktop) {
      // get children from page-content-wrapper inside main-layout and move to preview-content
      const children = this.contentWrapper.getChildren();
      this.remove(this.navbar);
      this.navbar = new DesktopNavbar();
      if (children[0]) {
        this.navbar.preview.show(
          new UIElement(children[0]),
          true,
          window.innerWidth - 52,
          true,
        );
        window.dispatchEvent(new CustomEvent('preview:expand'));
      }
      this.contentWrapper.clear();
      this.contentWrapper.add(new ProjectPage());
    }

    if (IS_MOBILE() && !IS_APP()) {
      this.addClass('flex-col-reverse');
      this.contentWrapper.setStyle('height', ['calc(100dvh - 60px)']);
      if (window.location.pathname === '/projects') {
        const projects = document.querySelector('#projects-page');
        const projectsContent = new UIElement(projects);
        MainLayout.setContent(projectsContent);
      }
    } else {
      this.removeClass('flex-col-reverse');
      this.contentWrapper.setStyle('height', ['100%']);
    }

    this.addFront(this.navbar);
  }

  shouldHideSidebar(title) {
    const hiddenSidebarPages = [
      'Register',
      'Login',
      'Public Models',
      'Shared Model',
      'Verify',
      'O-Hive Gallery',
    ];
    if (!UserState.user) {
      hiddenSidebarPages.push('Help');
      hiddenSidebarPages.push('Privacy');
    }
    this.hideNavbar = hiddenSidebarPages.includes(title);
    return this.hideNavbar;
  }

  setContent(component) {
    if (!component?.dom) return;
    this.contentWrapper.clear();
    if (component instanceof UIElement) {
      this.contentWrapper.add(component);
    } else {
      this.contentWrapper.dom.appendChild(component);
    }
  }

  toggleSidebar(visible) {
    const isCurrentlyVisible = !this.navbar.hasClass('hidden');
    if (visible !== isCurrentlyVisible) {
      if (visible) {
        this.navbar.removeClass('hidden');
      } else {
        this.navbar.addClass('hidden');
      }
    }
  }
}
const MainLayout = new _MainLayout();
export default MainLayout;
